import { ChargeState } from "@oysterhr/schema"
import { ClientInvoicePaymentState } from "../constants/invoices"

export const getClientInvoiceChargeState = ({
  chargeState,
}: {
  chargeState: ChargeState
}): ClientInvoicePaymentState => {
  if (chargeState === ChargeState.AutomatedProcessConfirmed) {
    return ChargeState.AutomatedProcessInProgress
  }

  return chargeState
}
